import { LoadState } from "../../constants/enums";
import { IAgentDashboardInformation, IAgentDashboardInformationState } from "./agentDashboard.types";

export const defaultAgentDashboardInformation:IAgentDashboardInformation={
    user_prospect_id:0,
    user_prospect_dim_id:0,
    user_name:"",
    contact_no:"",
    email_id:"",
    state:"",
    city:"",
    area:"",
    pin_code:"",
    address:"",
    gstin:"",
    vehicle_no:"",
    make_name:"",
    model_name:"",
    registration_year:"",
    package_name:"",
    package_id:0,
    package_price:0,
    package_period:0,
    package_services:0,
    created_by:0,
    sales_lead_id:0,
    manager_id:null,
    created_from:"",
    created_at:"",
    fe_id:0,
    promo_code:"",
    referral_code:"",
    partner_id:0,
    gst_percentage:0,
    gst_amount:0,
    iteration:0,
    payment_mode:"",
    payment_status:"",
    membership_code:"",
    payment_date:"",
    status:"",
    comment:"",
    remark:"",
    insert_dt:"",
}

export const defaultAgentDashbaordInfoState:IAgentDashboardInformationState={
  list: {
    data: [],
    totalRecords: 0,
    currentRecords:0,
    totalSum:0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  agentDashboardData: {
    data: defaultAgentDashboardInformation,
    loading: LoadState.NotLoaded,
    error: null,
  },
}